import React from 'react';
import Catch from '../utils/Catch';
import Adsense from 'react-adsense';
class Ad extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true };
    this.resize = this.resize.bind(this);
  }
  resize() {
    this.setState({ loading: true });
    setTimeout(() => this.setState({ loading: false }), 1000);
  }
  componentDidMount() {
    this.setState({ loading: false });
    window.addEventListener('resize', this.resize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }
  render() {
    return (
      <Catch>
        {this.state.loading ? null : (
          <Adsense.Google
            style={{ display: 'block' }}
            format="auto"
            slot="7144769766"
            client="ca-pub-2581767732612872"
          />
        )}
      </Catch>
    );
  }
}
export default Ad;
